import { useSelector } from 'src/store/store';
import VisitorSiteBar from 'src/components/siteBar/visitorSiteBar';
import DesktopSiteBar from 'src/components/siteBar/desktopSiteBar';
import MobileSiteBarTop from 'src/components/siteBar/mobileSiteBarTop';
import MobileSiteBarBottom from 'src/components/siteBar/mobileSiteBarBottom';

export default function SiteBar(): JSX.Element {
  const { currentUser } = useSelector(({ context }) => context);
  return !currentUser
    ? <VisitorSiteBar />
    : (
      <nav aria-label="main navigation">
        <MobileSiteBarTop />
        <MobileSiteBarBottom />
        <DesktopSiteBar />
      </nav>
    );
}
